import printersConfig, {
    moduleName as printersModuleName,
} from "./Printers/config";
import printsConfig, {
    moduleName as printsModuleName,
} from "./Prints/config";

import ProjectContext from "app/App/context";
import IConfig from "interfaces/IConfig";
import { registerModule } from "moduleConfig";
import { registerRoutings } from "rootRouting";
import { registerProjects } from "rootProjects";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";

export const moduleName = "Print";
export const project = "print";
export const url = `/print`;

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];
    const routingChildrens = [];

    const printers = printersConfig(permissions, url);
    if (printers.config.active) {
        config.active = true;
        registerModule(printersModuleName, printers.config);
        routingChildrens.push(...printers.routing);
    }

    const prints = printsConfig(permissions, url);
    if (prints.config.active) {
        config.active = true;
        registerModule(printsModuleName, prints.config);
        routingChildrens.push(...prints.routing);
    }

    if (routingChildrens.length > 0) {
        routing.push({
            path: url + "/*",
            children: routingChildrens,
            element: (
                <ProjectContext.Provider value={{ project, url }}>
                    <AsyncComponent path="Print/index" />
                </ProjectContext.Provider>
            ),
        });
    }

    if (config.active) {
        registerProjects([
            {
                id: project,
                name: "Print",
                icon: "print",
                url: `${url}`,
                priority: 500,
            },
        ]);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
